import image1 from "../../assets/images/Slider1.jpg";
import image2 from "../../assets/images/Slider2.jpg";
import image3 from "../../assets/images/Slider3.jpg";
import image4 from "../../assets/images/Slider4.jpg";
import image5 from "../../assets/images/Slider5.jpg";
import image6 from "../../assets/images/Slider6.jpg";
import image7 from "../../assets/images/Slider7.jpg";
import image8 from "../../assets/images/Slider8.jpg";
export const data = [image1, image2, image3, image4, image5, image6,image7,image8 ];
